var React = require('react');
var ReactNative = require('react-native');
var ListView = require('./wrappers/ListView-wrapper');

var Animated = require('./wrappers/Animated')

var Globals = require('./Globals');
var PlatformConstants = require('./constants/PlatformConstants');

var Drawer = require('./wrappers/react-native-drawer-wrapper');

var Menu = require('./menu');
var FeedCard = require('./feedCard.js');
var Icon = require('./wrappers/ReUpIcon');
var Meter = require('./Meter.js');
var Category = require('./category.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpText = require('./ReUpText');
var ModelConstants = require('./constants/ModelConstants.js');
var NetworkManager = require('./NetworkManager.js');
var ShadowView = require('./ShadowView.js');

var Svg = require('./wrappers/react-native-svg-wrapper');
var {
    Path,
    G,
    Circle
} = Svg;

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKButton,
} = MK;

var { BlurView, VibrancyView } = require('./wrappers/react-native-blur-wrapper');



var {
  AppRegistry,
  Text,
  View,
  ScrollView,
  Image,
  TouchableHighlight,
  Platform,
  StyleSheet,
  DeviceEventEmitter
} = ReactNative;


// Tells the library to detect iBeacons





var FEED_HEADER_HEIGHT = 80;
var FEED_CARD_COOLDOWN = 1000;

var dataBlob = {
}


var Feed = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      initialLayout : {x:0, y:0, width:0, height:0},
      getCards : function(featureNames, data){},
      dataDependencies : [],
      loggedOutDataDependencies : [],
      oldFixedHeaderAndroidEnabled : false,
    }
  },

  getInitialState : function()
  {
    var ds = new ListView.DataSource({
          rowHasChanged           : (row1, row2) => (row1 !== row2) || true || typeof row1.cardType === 'undefined' || typeof row2.cardType === 'undefined',
          sectionHeaderHasChanged : (s1, s2) => s1 !== s2
      });

    return {
      dataSource : ds.cloneWithRowsAndSections([{}]),
      topFeedSpacerHeight : this.props.initialLayout.height - FEED_HEADER_HEIGHT - Globals.FEED_TOP_SPACE_ADJUSTMENT,
      bottomFeedSpacerHeight : this.props.initialLayout.height - FEED_HEADER_HEIGHT - Globals.ACTION_BAR_HEIGHT,
      headerOffset : new Animated.Value(0),
      stickHeader : false,
      stickHeaderOffset : new Animated.Value(0),
      stickHeaderWidth : this.props.initialLayout.width,
      layout : this.props.initialLayout,
      cards : [],
      blurOpacity : new Animated.Value(0),
      fixedHeaderTop : new Animated.Value(0),
      fixedHeaderOpacity : new Animated.Value(1),
      fixedHeaderEnabled : false,
      nonFixedHeaderOpacity : new Animated.Value(1),
      nonFixedHeaderTop : new Animated.Value(0),
    }
  },

  _context : 0,
  _didPushUseCredit : false,
  componentDidMount : function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
//     Beacons.detectIBeacons()
//
//     // Start detecting all iBeacons in the nearby
//     try {
//       Beacons.startRangingBeaconsInRegion('REGION1')
//       console.log(`Beacons ranging started succesfully!`)
//     } catch (err) {
//       console.log(`Beacons ranging not started, error: ${error}`)
//     }
//
//     // Print a log of the detected iBeacons (1 per second)
//     DeviceEventEmitter.addListener('beaconsDidRange', (data) => {
//       console.log('Found beacons!', data.beacons)
//       if( data.beacons.length > 0 )
//       {
//         var beacon = data.beacons[0];
//         if( beacon.distance < .3 && !thisThing._didPushUseCredit  )
//         {
//           thisThing._didPushUseCredit = true;
//           PushNotification.localNotification({
//     /* Android Only Properties */
//     id: '0', // (optional) Valid unique 32 bit integer specified as string. default: Autogenerated Unique ID
//     ticker: "My Notification Ticker", // (optional)
//     autoCancel: true, // (optional) default: true
//     largeIcon: "ic_launcher", // (optional) default: "ic_launcher"
//     smallIcon: "ic_notification", // (optional) default: "ic_notification" with fallback for "ic_launcher"
//     bigText: "My big text that will be shown when notification is expanded", // (optional) default: "message" prop
//     subText: "This is a subText", // (optional) default: none
//     color: "red", // (optional) default: system default
//     vibrate: true, // (optional) default: true
//     vibration: 300, // vibration length in milliseconds, ignored if vibrate=false, default: 1000
//     tag: 'some_tag', // (optional) add tag to message
//     group: "group", // (optional) add group to message
//     ongoing: false, // (optional) set whether this is an "ongoing" notification
//
//     /* iOS and Android properties */
//     title: "My Notification Title", // (optional, for iOS this is only used in apple watch, the title will be the app name on other iOS devices)
//     message: "My Notification Message", // (required)
//     playSound: false, // (optional) default: true
//     soundName: 'default', // (optional) Sound to play when the notification is shown. Value of 'default' plays the default sound. It can be set to a custom sound such as 'android.resource://com.xyz/raw/my_sound'. It will look for the 'my_sound' audio file in 'res/raw' directory and play it. default: 'default' (default sound is played)
//     number: '10', // (optional) Valid 32 bit integer specified as string. default: none (Cannot be zero)
// });
//           appActions.requestFeatureName("UseCredit");
//         }
//       }
//     })

    appManager.loginCallBackStart = function()
    {
      appActions.requestPop(false);
      appActions.setSpinnerShown(true, "Logging in...");
      appManager.getCurrentUser(function(a)
      {
        thisThing.checkUserChanged();
      })
    }
    appManager.loginCallBackFinish = function()
    {
      appActions.requestPop(false);
      appActions.setSpinnerShown(false);
      appManager.getCurrentUser(function(a)
      {
        thisThing.checkUserChanged();
      })
    }
    var appActions = this.props.appActions;
    var feedFeatureNames = this.props.appManager.getFeedFeatureNames();
    var {dataDependencies, customDependencies} = this.props.dataDependencyRetriever(feedFeatureNames);

    this.props.appManager._eventEmitter.on('checkUserChanged', this.checkUserChanged, this._context++);

    appManager.getDataTypes(thisThing.props.allDependencyKeys, function(data)
    {
      thisThing.didUpdate(data)
    })

    NetworkManager.update(appManager, dataDependencies, function(newData)
    {
      if( customDependencies.length <= 0 )
      {
        thisThing.didUpdate(newData)
      }
      else
      {
        NetworkManager.retrieveCustomDataDependencies(appManager, customDependencies, newData, function(totalData)
        {
          thisThing.didUpdate(totalData);
        });
      }
    }, function(){});

    var thisThing = this;
    this.props.appManager.getSelfie(function(selfieURL)
    {
      thisThing.setState({selfieURL:selfieURL})
    })
  },

  componentWillUnmount : function()
  {
    this.props.appManager._eventEmitter.removeListener('checkUserChanged', this.checkUserChanged, this._context);
  },

  viewDidLayout : function(info)
  {
    var layout = info.nativeEvent.layout;
    var topFeedSpacerHeight = (Platform.OS !== 'ios' && Platform.OS !== 'web' && !this.props.oldFixedHeaderAndroidEnabled) ? 0 : layout.height - FEED_HEADER_HEIGHT - Globals.FEED_TOP_SPACE_ADJUSTMENT;
    if( JSON.stringify(layout) == JSON.stringify(this.state.layout) && topFeedSpacerHeight == this.state.topFeedSpacerHeight ) return;

    this.setState({layout:layout, topFeedSpacerHeight: topFeedSpacerHeight});
  },

  renderRow: function(rowData, sectionID, rowNumber)
  {
    if( typeof rowData.cardType === 'undefined' )
    {
      return null;
    }

    var thisThing = this;
    var appManager = this.props.appManager;
    var cardColor = appManager.getColorForKey("FeedCardColor");
    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
    var rippleColor = appManager.getColorForKey("FeedCardBannerColor", 0.2);
    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");

    return <FeedCard {...rowData}
            key={rowData.key}
            appManager={appManager}
            iconColor={bannerIconColor}
            bannerColor={bannerColor}
            cardColor={cardColor}
            titleColor={titleColor}
            bodyColor={bodyColor}
            rippleColor={rippleColor}
            cardHeight={(height) =>
              {
              }
            }/>
  },

  renderSectionHeader: function(sectionData, sectionID)
  {
    var loggedIn = this.props.appManager.isLoggedIn();

    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var locManager = this.props.appManager.getLocalizationManager();
    var profileColor = appManager.getColorForKey("ProfileColor");
    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
    var profileIconColor = appManager.getColorForKey("ProfileIconColor");
    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
    var profileImageColorLight = appManager.getColorForKey("ProfileImageColor", 0.2);

    var useCreditFeature = this.props.appManager.getFeatureForName("UseCredit");
    var creditIconName = "pay-shortcut";//typeof useCreditFeature === 'undefined' ? "" : useCreditFeature.data.icon.replace("fa-", "");
    var useCreditIsInFeed =  typeof useCreditFeature === 'undefined' ? false : useCreditFeature.data.shouldShowInFeed;

    var earnPointsFeature = this.props.appManager.getFeatureForName("EarnPoints")
    var rewardsIconName = typeof earnPointsFeature === 'undefined' ? "trophy" : earnPointsFeature.data.icon.replace("fa-", "");
    var rewardsIsInFeed =  typeof earnPointsFeature === 'undefined' ? false : earnPointsFeature.data.shouldShowInFeed;

    var creditPercentage = 0;
    var pointPercentage = 0;
    var creditString = "";
    var pointsString = "";
    var initials = "";

    if( loggedIn )
    {
      initials = appManager.currentUserInitials();
      var maxDollars = parseFloat(appManager.getLocalizationManager().getConstants()["CREDITS_FOR_MAX"]);
      var maxPoints = parseFloat(appManager.getLocalizationManager().getConstants()["TOTAL_POINTS_FOR_REWARD"]);
      var currDollars = parseFloat(appManager.currentUser()[ModelConstants.Credits]);
      var currPoints = parseFloat(appManager.currentUser()[ModelConstants.Points]);
      creditString = appManager.getLocalizationManager().localizedDollars(currDollars);
      pointsString = appManager.getLocalizationManager().localizedPts(currPoints);
      creditPercentage = parseFloat(currDollars / maxDollars);
      pointPercentage = parseFloat(currPoints / maxPoints);
    }

    var leftTextStyle = {backgroundColor:'transparent',margin:0,marginTop:0, marginLeft:2, width:FEED_HEADER_HEIGHT - 16 - 4, height:FEED_HEADER_HEIGHT - 16 - 4,borderRadius:(FEED_HEADER_HEIGHT - 16 - 4)/2, justifyContent:'center', alignItems:'center'};
    return (
      <View>
        <View style={[styles.feedHeader, {backgroundColor:profileColor, flexDirection:'row', justifyContent:'center', width:this.state.layout.width, height:FEED_HEADER_HEIGHT}]}>
          <View style={styles.feedHeaderLeftContainer}>
            <TouchableHighlight
              underlayColor={"transparent"}
              activeOpacity={0.9}
              onPress={()=>{ appActions.requestFeatureName("Settings")}}>
                <View style={[styles.profileImage, {borderColor:'transparent', backgroundColor:profileColor, backgroundColor:'transparent', borderWidth:0}]}>
                {
                  !loggedIn ?
                  <View style={leftTextStyle}>
                    <Icon name={"lock"} size={48} color={profileImageColor} />
                  </View>
                  :
                  typeof this.state.selfieURL !== 'undefined' && this.state.selfieURL != null && this.state.selfieURL.length > 0 ?

                  <View>
                    <ReUpText appManager={appManager} style={[styles.profileImageText, {color: profileImageColor, position: 'absolute', top:13, left:0, right: 0, bottom: 0 }]}>
                      {initials}
                    </ReUpText>
                    <Image source={{uri: this.state.selfieURL}} style={leftTextStyle}>
                    </Image>
                  </View>
                  :
                  <View style={leftTextStyle}>
                    <View><ReUpText appManager={appManager} style={[styles.profileImageText, {color:profileImageColor}]}>
                      {initials}
                    </ReUpText></View>
                  </View>
                }
                <Svg
                  height={FEED_HEADER_HEIGHT}
                  width={FEED_HEADER_HEIGHT}
                  style={{position:'absolute', top:-12,left:-12, backgroundColor:'transparent'}}
                >
                    <G scale="1">
                      <Circle cx={(FEED_HEADER_HEIGHT + 8)/2} cy={(FEED_HEADER_HEIGHT + 8)/2} r={(FEED_HEADER_HEIGHT - 16 - 4)/2} stroke={profileImageColor} stroke-width="2" fill={'transparent'} />
                    </G>
                </Svg>
              </View>
            </TouchableHighlight>
          </View>
          {
            loggedIn ?
            <View style={[styles.feedHeaderCenterContainer]}>
              {
                useCreditIsInFeed ?
                <View><MKButton onPress={() => appActions.requestFeatureName("UseCredit")}>
                  <View  style={{flexDirection:'row'}}>
                    <Meter height={FEED_HEADER_HEIGHT/3} initialPercent={creditPercentage} innerColor={profileMeterColor} outerColor={profileMeterBackgroundColor} style={{flex:1}}>
                      <Icon name={creditIconName} size={FEED_HEADER_HEIGHT/5} color={profileIconColor} style={{backgroundColor:'transparent'}} />
                    </Meter>
                    <View style={{width:FEED_HEADER_HEIGHT, alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
                      <View>
                        <ReUpText appManager={appManager} isTitle={true} style={[styles.feedHeaderInfo, {color:profileTitleColor}]}>
                          {creditString}
                        </ReUpText>
                      </View>
                    </View>
                  </View>
                </MKButton></View> : null
              }
              {
                rewardsIsInFeed ?
                <View><MKButton onPress={() => appActions.requestFeatureName("Rewards")} style={{flexDirection:'row'}}>
                  <View  style={{flexDirection:'row'}}>
                    <Meter height={FEED_HEADER_HEIGHT/3} initialPercent={pointPercentage} innerColor={profileMeterColor} outerColor={profileMeterBackgroundColor} style={{flex:1}}>
                      <Icon name={rewardsIconName} size={FEED_HEADER_HEIGHT/5} color={profileIconColor} style={{backgroundColor:'transparent', alignSelf:'center'}} />
                    </Meter>
                    <View style={{width:FEED_HEADER_HEIGHT, alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
                      <View>
                        <ReUpText appManager={appManager} isTitle={true} style={[styles.feedHeaderInfo, {color:profileTitleColor}]}>
                          {pointsString}
                        </ReUpText>
                      </View>
                    </View>
                  </View>
                </MKButton></View> : null
              }
            </View>
            :
            <View style={styles.feedHeaderCenterContainer}>
              <View />
              <View><ReUpText isTitle={true} appManager={typeof appManager === 'undefined' ? null : appManager} style={[styles.feedHeaderInfo, {color:profileTitleColor}]}>
                {locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")}
              </ReUpText></View>
              <View />
            </View>
          }
        </View>
      </View>
    )

  },

  renderFooter: function()
  {
    return (
      <View />
    )
  },

  renderHeader: function()
  {
    return (
      <View style={[styles.topFeedSpacer, {height:this.state.topFeedSpacerHeight}]} />
    )
  },

  selfieUpdated: function(data)
  {
    if( data.selfieURL != this.state.selfieURL ) this.setState({selfieURL:data.selfieURL})
  },

  checkUserChanged : function()
  {
    var appManager = this.props.appManager;
    var loggedIn = this.props.appManager.isLoggedIn();
    if( loggedIn != this._loggedInRendered )
    {
      this._loggedInRendered = loggedIn;
      this.didUpdate({});
    }
  },

  _loggedIn: false,
  _loggedInRendered: false,
  _hasGoneUp: false,
  _cardUpdateTimeout: null,
  _data: {},
  didUpdate: function(data)
  {
    var thisThing = this;
    var appManager = this.props.appManager;

    var loggedIn = this.props.appManager.isLoggedIn();
    if( loggedIn != this._loggedIn )
    {
      // logged in status changed, should refresh feed
      this._hasGoneUp = false;
      var feedFeatureNames = this.props.appManager.getFeedFeatureNames();
      var {dataDependencies, customDependencies} = this.props.dataDependencyRetriever(feedFeatureNames);
      NetworkManager.update(this.props.appManager, dataDependencies, function(newData)
      {
        if( customDependencies.length <= 0 )
        {
          thisThing.goUp();
        }
        else
        {
          NetworkManager.retrieveCustomDataDependencies(appManager, customDependencies, newData, function(totalData)
          {
            thisThing.goUp();
          });
        }
      }, function(){});
      this._loggedIn = loggedIn;
    }
    else
    {
      setTimeout(function()
      {
        if( !thisThing._hasGoneUp ) thisThing.goUp();
      }, 2000)
    }

    var thisThing = this;
    thisThing._cardUpdateTimeout = null;
    var feedFeatureNames = thisThing.props.appManager.getFeedFeatureNames();
    var feedFeatures = thisThing.props.appManager.getFeedFeatures();

    thisThing.props.appManager.getDataTypes(thisThing.props.allDependencyKeys,function(data)
    {
      if( typeof data !== 'undefined' )
      {
       var cards = thisThing.props.getCards(feedFeatureNames, thisThing.props.appManager, thisThing.props.appActions, data, feedFeatures);
        cards.push({footerHeight:thisThing.props.initialLayout.height, date:(new Date())});
        thisThing.props.appManager.getSelfie(function(selfieURL)
        {
          if( (thisThing.state.bottomFeedSpacerHeight != thisThing.props.initialLayout.height - FEED_HEADER_HEIGHT - Globals.ACTION_BAR_HEIGHT) ||
              (thisThing.state.selfieURL == selfieURL) ||
              (JSON.stringify(thisThing.state.cards) != JSON.stringify(cards)) )
          {
            thisThing.setState({selfieURL:selfieURL, cards:cards, dataSource : thisThing.state.dataSource.cloneWithRowsAndSections([cards]), bottomFeedSpacerHeight : thisThing.props.initialLayout.height - FEED_HEADER_HEIGHT - Globals.ACTION_BAR_HEIGHT});
          }
        })
        if( !thisThing._hasGoneUp ) thisThing.goUp();
      }
    })
  },

  _reupScrollView : null,
  reupScrollViewDidMount: function(reupScrollView)
  {
    this._reupScrollView = reupScrollView;
  },

  goUp: function()
  {
    if( this._reupScrollView != null )
    {
      var thisThing = this;
      setTimeout(function()
      {
        if( thisThing._reupScrollView == null ) return;
        if( Platform.OS != 'ios' ) thisThing._reupScrollView.scrollTo(0, thisThing.state.layout.height - Globals.FEED_TOP_SPACE_ADJUSTMENT - FEED_HEADER_HEIGHT)
        else thisThing._reupScrollView.scrollTo(0, thisThing.state.topFeedSpacerHeight)
      }, 1000)
      this._hasGoneUp = true;
    }
  },

  _isBlurred : false,
  setIsBlurred: function(isBlurred)
  {
    if( this._isBlurred != isBlurred )
    {
      this._isBlurred = isBlurred;
      Animated.timing(
        this.state.blurOpacity,
        {toValue: isBlurred ? 1 : 0, duration:100},
      ).start(function()
      {

      });
    }
  },

  feedDidScroll: function(info)
  {
    if( typeof info.nativeEvent.contentOffset === 'undefined' ) return;
    var offset = info.nativeEvent.contentOffset.y;
    if( this._ref_blurView )
    {
      this._ref_blurView.setOpacity(offset/(this.state.layout.height - FEED_HEADER_HEIGHT - Globals.FEED_TOP_SPACE_ADJUSTMENT));
    }
    if( this._isBlurred )
    {
      this.setIsBlurred(offset > 5);
    }
    else
    {
      this.setIsBlurred(offset >= (this.state.topFeedSpacerHeight - 5));
    }

    if( Platform.OS != 'ios' )
    {
      if( offset > (this.state.topFeedSpacerHeight) && !this.state.fixedHeaderEnabled && this.props.oldFixedHeaderAndroidEnabled )
      {
        this.setState({fixedHeaderEnabled:true, fixedHeaderTop:new Animated.Value(this.state.topFeedSpacerHeight - offset + Globals.ACTION_BAR_HEIGHT)});
        //
        // Animated.timing(
        //   this.state.fixedHeaderOpacity,
        //   {toValue: 1, duration:200},
        // ).start(function()
        // {
        //
        // });

        // Animated.timing(
        //   this.state.fixedHeaderTop,
        //   {toValue: Globals.ACTION_BAR_HEIGHT, duration:200},
        // ).start(function()
        // {
        //
        // });

        Animated.spring(this.state.fixedHeaderTop,
        {
          toValue: Globals.ACTION_BAR_HEIGHT,
          friction: 6
        }).start();

        Animated.timing(
          this.state.nonFixedHeaderOpacity,
          {toValue: 0, duration:0},
        ).start(function()
        {

        });
      }
      else if( offset < (this.state.topFeedSpacerHeight) && this.state.fixedHeaderEnabled )
      {
        this.setState({fixedHeaderEnabled:false, nonFixedHeaderTop:new Animated.Value(this.state.topFeedSpacerHeight - offset)});

        Animated.timing(
          this.state.nonFixedHeaderOpacity,
          {toValue: 1, duration:0},
        ).start(function()
        {

        });

        Animated.spring(this.state.nonFixedHeaderTop,
        {
          toValue: 0,
          friction: 6
        }).start();

        // Animated.timing(
        //   this.state.fixedHeaderOpacity,
        //   {toValue: 0, duration:200},
        // ).start(function()
        // {
        //
        // });
      }
    }
  },

  render: function()
  {
    // return <View style={{width:100, height:100, backgroundColor:'red'}} />
    var onScroll = this.onScroll;
    var thisFeed = this;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var scrollDidMount = this.reupScrollViewDidMount;
    var bgImage = this.props.appManager.absoluteResourceForPath(this.props.featureData.name + '/' + this.props.featureData.bgImage);

    return (
      <View style={styles.container} onLayout={this.viewDidLayout}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <Drawer
          ref={(a)=>{if( a != null ) appActions.setDrawer(a)}}
          type="overlay"
          onOpen={function(){appActions.drawerDidOpen()}}
          onClose={function(){appActions.drawerDidClose()}}
          content={<Menu key="menu" ref={(c) => { this._ref_menu = c; }}
            menuFeatures={this.props.appManager ? this.props.appManager.getMenuFeatures() : []}
            menuTitleColor={appManager.getColorForKey("MenuTitleColor")}
            menuIconColor={appManager.getColorForKey("MenuIconColor")}
            menuHighlightColor={appManager.getColorForKey("MenuSelectionColor")}
            menuBackgroundColor={appManager.getColorForKey("MenuColor")}
            menuSeparatorColor={appManager.getColorForKey("MenuIconColor",0.4)}
            AppActions={this.props.appActions}
            appActions={this.props.appActions}
            appManager={appManager}
            />}
          closedDrawerOffset={-3}
          openDrawerOffset={0.2}
          panOpenMask={.1}
          panCloseMask={.2}
          negotiatePan={true}
          tweenHandler={Drawer.tweenPresets.parallax}
          allowPan={true}
          negotiatePan={true}
          styles={{
              drawer: { shadowColor: '#000000', shadowOpacity: 0.8, shadowRadius: 3},
              main: {paddingLeft: 3},
            }}
          tweenHandler={(ratio) => ({
            main: { opacity:(2-ratio)/2 }
          })}
          >
          <BlurView ref={(c) => { this._ref_blurView = c; }} blurType="light" initialOpacity={0} style={{position:'absolute', left:0, right:0, top:0, bottom:0}} imageName={bgImage} imageKey={appManager.getImageKey("bg")} />
          <ReUpScrollView  shouldOverlayRefreshView={true}
            key={"feedScroll"} shadowEnabled={false}
            bounces={true} onScroll={this.feedDidScroll} scrollEventThrottle={20}
            style={styles.scrollContainer}
            responder={thisFeed}
            stickyHeaderIndices={[Platform.OS === 'ios' ? 2 : 1]}
            style={{height:this.state.layout.height}} >
            <View style={{height:this.state.layout.height-FEED_HEADER_HEIGHT - (Platform.OS == 'web' ? Globals.ACTION_BAR_HEIGHT : 0)}} />
            {this.renderSectionHeader()}
            <View style={{flexDirection:'row'}}>
              <View style={{height:this.state.layout.height-FEED_HEADER_HEIGHT - Globals.ACTION_BAR_HEIGHT}} />
              <View style={{flex:1, paddingBottom:8}}>
              {
                this.state.cards.map((card, index)=>
                {
                  return thisFeed.renderRow(card);
                })
              }
              </View>
            </View>
          </ReUpScrollView>
        </Drawer>
         {
           this.state.fixedHeaderEnabled ?
           <Animated.View style={{position:'absolute',top:this.state.fixedHeaderTop,left:0,right:0,height:FEED_HEADER_HEIGHT+2,opacity:this.state.fixedHeaderOpacity}}>
             {this.renderSectionHeader(null,-1)}
             <ShadowView appManager={this.props.appManager} layout={this.state.layout} />
           </Animated.View>
           :
           null
         }
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  feedHeader: {
    height:FEED_HEADER_HEIGHT,
    flexDirection:'row',
  },
  feedHeaderLeftContainer: {
    padding:10,
    width:FEED_HEADER_HEIGHT + 4,
    height:FEED_HEADER_HEIGHT,
    alignItems:'center',
    justifyContent:'center',
  },
  profileImage: {
    height:FEED_HEADER_HEIGHT - 16,
    width:FEED_HEADER_HEIGHT - 16,
    borderRadius:(FEED_HEADER_HEIGHT - 16)/2,
    borderWidth:2,
    borderColor:'black',
    justifyContent:'center',
  },
  profileImageText: {
    textAlign:'center',
    fontSize:(FEED_HEADER_HEIGHT - 20)/2,
    fontWeight:'bold',
    backgroundColor:'transparent'
  },
  feedHeaderCenterContainer: {
    height:FEED_HEADER_HEIGHT,
    flexDirection:'column',
    paddingVertical:10,
    flex:1,
    justifyContent:'space-around',
  },

  feedHeaderRightContainer: {
    paddingVertical:10,
    width:FEED_HEADER_HEIGHT + 4,
    height:FEED_HEADER_HEIGHT,
    justifyContent:'space-between',
    alignItems:'center',
  },
  feedHeaderInfo: {
    fontWeight:'bold'
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  topFeedSpacer: {
  },
  bottomFeedSpacer: {
  },
  dummyContainer: {
    position: 'absolute',
    flex: 1,
  },
  scrollContainer: {
    flex: 1,
  },
  card: {
    height:200,
    margin:10,
    backgroundColor: 'brown',
  },
  image: {
    position: 'absolute',
    flex: 1
  },
});

module.exports = Feed;
